import { Client } from '@stomp/stompjs';
import PubSub from 'pubsub-js';

const apiUrl = process.env.REACT_APP_WS_URL;

const SOCKET_URL = apiUrl+'/mlive-channel';

var connected = false;
let onDisconnected = () => {
    console.warn("diconnected")
    connected = false;
    PubSub.publish('eventDisconnected'); 
}
let onConnected = () => {
    console.warn("connected")
    PubSub.publish('eventConnected');
    connected = true;
}

 export const client = new Client({
    brokerURL: SOCKET_URL,
    reconnectDelay: 1000,
    heartbeatIncoming: 4000,
    heartbeatOutgoing: 4000,
    onConnect: onConnected,
    onDisconnect: onDisconnected,
    onStompError: (frame) => {
        console.error('Broker reported error:', frame.headers['message']);
        console.error('Details:', frame.body);
      },
      onWebSocketError: (event) => {
        console.error('WebSocket error occurred:', event);
      // PubSub.publish('failed');
      }
});

// Reconnection logic
const attemptReconnect = (url, retryData) => {
    console.warn('Attempting to reconnect...');
    var intv = setInterval(() => {
        if (!client.active) {  // Check if the client is disconnected
            client.activate(); // Reconnect
            clearInterval(intv);
        } else {
            clearInterval(intv);
            sendMessage (url, retryData);
        }
    }, 3000); // Adjust the delay as needed
};

client.activate();

//method to subsribe channel
export function ownSubscribe(destination, callbackFunction,subscribeId) {
	if (client != null && client != undefined && client.connected) {
		console.warn("Subscribe", destination);
		return client.subscribe(destination, callbackFunction,{id:subscribeId});
	}else if(!client.connected){
        console.warn("Client not connected. Retrying subscription...");
        setTimeout(() => {
            if(client.connected){
                ownSubscribe(destination,callbackFunction,subscribeId);
            } else {
                PubSub.publish('subFailed');
            }
        }, 1000);
    }
}

export function unSubscribe(id) {
	if (client != null && client != undefined && client.connected) {
		console.warn("Unsubscribe");
		return client.unsubscribe(id);
	}
}

export function isConnected(){
    return connected;
}
export const sendMessage = (url, data) => {
     const userAgent = navigator.userAgent;
    if (client != null && client != undefined && client.connected) {
      //  console.warn("Sending Data");
         client.publish({ destination: url, headers:{ id: 123, 'User-Agent': userAgent }, body: data })
    }else if(!client.connected){
        setTimeout(() => {
            try {
                if(client?.connected) {
                    console.warn("Sending Data ");
                    client.publish({ destination: url, headers:{ id: 123, 'User-Agent': userAgent }, body: data });
                } 
            } catch (error) {
                console.error("Failed to publish message:", error);
                attemptReconnect(url, data);
            }
        }, 1000);
    }
};
export default  class StompSocket{}
